export default function StockBar({ stock }) {
  const low = stock <= 5;
  const pct = Math.max(8, Math.min(100, (stock / 30) * 100));
  return (
    <div className="space-y-2" data-testid="stock-bar">
      <div className="flex items-center justify-between">
        <span className="ie-overline text-text-secondary">Atelier Stock</span>
        <span className={`ie-overline ${low ? "text-brand-accent" : ""}`}>
          {low ? `Only ${stock} left` : `${stock} in stock`}
        </span>
      </div>
      <div className="h-px bg-border relative overflow-hidden">
        <div
          className={`absolute inset-y-0 left-0 ${low ? "bg-brand-accent" : "bg-foreground"}`}
          style={{ width: `${pct}%`, height: 1 }}
        />
      </div>
    </div>
  );
}
